import { useEffect, useState } from "react";
import { useIsFetching } from "react-query";
import {
  configuratorQueryKeys,
  designerQueryKeys,
  selectionQueryKeys,
} from "../react-query/queryConstants";

const selectionBootstrapKeys = new Set([
  selectionQueryKeys.getVentilationInformation,
  configuratorQueryKeys.getConfigurationInstances,
  configuratorQueryKeys.GetConfigurationInstance,
  configuratorQueryKeys.GetSelectedUnitModelName,
  designerQueryKeys.getAHUDesignerManaager,
]);

export function useSelectionBootstrap() {
  const fetchingCount = useIsFetching({
    predicate: (query) =>
      selectionBootstrapKeys.has(query.queryKey?.[0]),
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoading || fetchingCount !== 0) return;

    // Require a short quiet period so dependent instance queries can register.
    const timer = setTimeout(() => setIsLoading(false), 100);
    return () => clearTimeout(timer);
  }, [fetchingCount, isLoading]);

  return isLoading;
}
